import { enumRoles, enumPermissions as permission } from "data/enums/authorization";
import { moduleNames } from "data/enums/modules";

const { ADMIN, MANAGER, ADVERTISER, AFFILIATE, SUPPORT, FINANCE } = enumRoles

const allRoles = [ADMIN, MANAGER, ADVERTISER, AFFILIATE, SUPPORT, FINANCE]
const allAdminRoles = [ADMIN, MANAGER, SUPPORT, FINANCE]
// const [AFFILIATE] = [AFFILIATE];
// const allUserRoles = [ADVERTISER, AFFILIATE]
const affiliateRoles = [AFFILIATE]

const routes = [
  {
    id: 'admin',
    auth: {
      roles: allAdminRoles
    },
    modules: [
      {
        id: moduleNames.ADMIN_DASHBOARD, to: '/admin/dashboard',
        auth: { roles: allAdminRoles, permissions: [], home: true },
      },
      {
        id: moduleNames.ADMIN_REPORT_DROPDOWN, to: '/admin/report',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_BALANCE, permission.ADMIN_REPORT_OFFERS, permission.ADMIN_REPORT_USERS, permission.ADMIN_REPORT_DYNAMICS, permission.ADMIN_REPORT_ORDERS] },
        routes: [
          {
            id: moduleNames.ADMIN_REPORT_BALANCE, to: '/admin/report/balance',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_BALANCE] },
          },
          {
            id: moduleNames.ADMIN_REPORT_OFFERS, to: '/admin/report/offers',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_OFFERS] },
          },
          {
            id: moduleNames.ADMIN_REPORT_USERS, to: '/admin/report/users',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_USERS] },
          },
          {
            id: moduleNames.ADMIN_REPORT_ADVERTISERS, to: '/admin/report/advertisers',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_ADVERTISERS] },
          },
          {
            id: moduleNames.ADMIN_REPORT_COUNTRIES, to: '/admin/report/countries',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_COUNTRIES] },
          },
          {
            id: moduleNames.ADMIN_REPORT_DYNAMICS, to: '/admin/report/dynamic',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_DYNAMICS] },
          },
          {
            id: moduleNames.ADMIN_REPORT_ORDERS, to: '/admin/report/orders',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_REPORT_ORDERS] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_USERS_DROPDOWN, to: '/admin/users',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_USERS_LIST, permission.ADMIN_USERS_UNAPPROVED_LIST] },
        routes: [
          {
            id: moduleNames.ADMIN_USERS, to: '/admin/users/all',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_USERS_LIST] },
          },
          {
            id: moduleNames.ADMIN_USERS_UNAPPROVED, to: '/admin/users/unapproved',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_USERS_UNAPPROVED_LIST] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_OFFERS_DROPDOWN, to: '/admin/offers',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_OFFERS_LIST, permission.ADMIN_OFFERS_ACCESS_LIST] },
        routes: [
          {
            id: moduleNames.ADMIN_OFFERS, to: '/admin/offers/list',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_OFFERS_LIST] },
          },
          {
            id: moduleNames.ADMIN_OFFERS_ACCESS, to: '/admin/offers/access',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_OFFERS_ACCESS_LIST] },
          },
          {
            id: moduleNames.ADMIN_OFFERS_BLACKLIST_USERS, to: '/admin/offers/blacklist-users',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_OFFERS_BLACKLIST_USERS_LIST] },
          },
          {
            id: moduleNames.ADMIN_OFFERS_PAYOUT_OFFERS, to: '/admin/offers/payout',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_OFFERS_PAYOUT_LIST] },
          },
          {
            id: moduleNames.ADMIN_OFFERS_USERS_GUARANTEES, to: '/admin/offers/users-guarantees',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_OFFERS_USERS_GUARANTEES_LIST] },
          },
          {
            id: moduleNames.ADMIN_OFFERS_TRACKING_LINKS, to: '/admin/offers/tracking-links',
            auth: { roles: allAdminRoles, permissions: [] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_GUARANTEES_DROPDOWN, to: '/admin/guarantees',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_GUARANTEES_LOGS_LIST] },
        routes: [
          {
            id: moduleNames.ADMIN_GUARANTEES_LOGS, to: '/admin/guarantees/logs',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_GUARANTEES_LOGS_LIST] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_DOMAINS, to: '/admin/domains',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_DOMAINS_LIST] },
      },
      {
        id: moduleNames.ADMIN_NEWS, to: '/admin/news',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_NEWS_LIST] },
      },
      {
        id: moduleNames.ADMIN_PAGES_DROPDOWN, to: '/admin/pages',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_LANDINGS_LIST, permission.ADMIN_PRELANDINGS_LIST] },
        routes: [
          {
            id: moduleNames.ADMIN_LANDINGS, to: '/admin/pages/landings',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_LANDINGS_LIST] },
          },
          {
            id: moduleNames.ADMIN_PRELANDINGS, to: '/admin/pages/prelandings',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_PRELANDINGS_LIST] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_PAYMENTS, to: '/admin/payments',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_PAYMENTS_LIST] },
      },
      {
        id: moduleNames.ADMIN_ORDERS_DROPDOWN, to: '/admin/orders',
        auth: { roles: allAdminRoles, permissions: [] },
        routes: [
          {
            id: moduleNames.ADMIN_ORDERS, to: '/admin/orders/list',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_ORDERS_LIST] },
          },
          {
            id: moduleNames.ADMIN_ORDERS_ERRORS, to: '/admin/orders/errors',
            auth: { roles: allAdminRoles, permissions: [permission.ADMIN_ORDERS_ERRORS_LIST] },
          },
          {
            id: moduleNames.ADMIN_OFFERS_SUBSCRIPTIONS, to: '/admin/orders/subscriptions',
            auth: { roles: allAdminRoles, permissions: [] },
          },
        ]
      },
      {
        id: moduleNames.ADMIN_TOPUPS, to: '/admin/topups',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_TOPUPS_LIST] },
      },
      {
        id: moduleNames.ADMIN_BALANCE, to: '/admin/balance',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_BALANCE_LIST] },
      },
      {
        id: moduleNames.ADMIN_POSTBACK_LOGS, to: '/admin/postback-logs',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_POSTBACK_LOGS_LIST] },
      },
      {
        id: moduleNames.ADMIN_LOGIN_HISTORY, to: '/admin/login-history',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_LOGIN_HISTORY_LIST] },
      },
      {
        id: moduleNames.ADMIN_LOGS_DROPDOWN, to: '/admin/logs',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_LOGS_QUEUE_EMAIL] },
        routes: [
          {
            id: moduleNames.ADMIN_LOGS_QUEUE_EMAIL, to: '/admin/logs/queue-email',
            auth: { roles: allAdminRoles, permissions: [] },
          }

        ]
      },
      /* {
        id: moduleNames.ADMIN_CHANGELOG, to: '/admin/change-log',
        auth: { roles: allAdminRoles, permissions: [permission.ADMIN_CHANGELOG_LIST] },
      }, */

    ]
  },
  {
    id: 'advertiser',
    auth: {
      roles: [ADVERTISER]
    },
    modules: [
      {
        id: moduleNames.ADVERTISER_DASHBOARD, to: '/advertiser/dashboard',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_OFFERS, to: '/advertiser/offers',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_ORDERS, to: '/advertiser/orders',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_TOPUPS, to: '/advertiser/topups',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.ADVERTISER_LOGIN_HISTORY, to: '/advertiser/login-history',
        auth: { roles: [ADVERTISER], permissions: [], permissionsExclude: true },
      },
    ]
  },
  {
    id: 'affiliate',
    auth: {
      roles: [AFFILIATE]
    },
    modules: [
      {
        id: moduleNames.AFFILIATE_DASHBOARD, to: '/affiliate/dashboard',
        auth: { roles: affiliateRoles, permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.AFFILIATE_REPORT, to: '/affiliate/report',
        auth: { roles: affiliateRoles, permissions: [], permissionsExclude: true },
      },
      {
        id: moduleNames.AFFILIATE_OFFERS_DROPDOWN, to: '/affiliate/offers',
        auth: { roles: [AFFILIATE], permissions: [] },
        routes: [
          {
            id: moduleNames.AFFILIATE_OFFERS_ALL, to: '/affiliate/offers/all',
            auth: { roles: [AFFILIATE], permissions: [] },
          },
          {
            id: moduleNames.AFFILIATE_OFFERS_HOT, to: '/affiliate/offers/hot',
            auth: { roles: [AFFILIATE], permissions: [] },
          },
        ]
      },
      {
        id: moduleNames.AFFILIATE_POSTBACK_DROPDOWN, to: '/affiliate/postback',
        auth: { roles: [AFFILIATE], permissions: [] },
        routes: [
          {
            id: moduleNames.AFFILIATE_POSTBACK, to: '/affiliate/postback/list',
            auth: { roles: [AFFILIATE], permissions: [] },
          },
          {
            id: moduleNames.AFFILIATE_POSTBACK_LOGS, to: '/affiliate/postback/logs',
            auth: { roles: [AFFILIATE], permissions: [] },
          },
        ]
      },
      {
        id: moduleNames.AFFILIATE_ORDERS_DROPDOWN, to: '/affiliate/orders',
        auth: { roles: [AFFILIATE], permissions: [] },
        routes: [
          {
            id: moduleNames.AFFILIATE_ORDERS, to: '/affiliate/orders/list',
            auth: { roles: [AFFILIATE], permissions: [], permissionsExclude: true },
          },
          {
            id: moduleNames.AFFILIATE_OFFERS_SUBSCRIPTIONS, to: '/affiliate/orders/subscriptions',
            auth: { roles: [AFFILIATE], permissions: [], },
          },
        ]
      },
      {
        id: moduleNames.AFFILIATE_DOMAINS, to: '/affiliate/domains',
        auth: { roles: [AFFILIATE], permissions: [], permissionExclude: true },
      },
      {
        id: moduleNames.AFFILIATE_BALANCE, to: '/affiliate/balance',
        auth: { roles: [AFFILIATE], permissions: [] },
      },
      {
        id: moduleNames.AFFILIATE_PAYMENTS, to: '/affiliate/payments',
        auth: { roles: [AFFILIATE], permissions: [] },
        routes: [
          {
            id: moduleNames.AFFILIATE_PAYMENTS_REQUEST, to: '/affiliate/payments/request',
            auth: { roles: [AFFILIATE], permissions: [] },
          },
          {
            id: moduleNames.AFFILIATE_PAYMENTS_SETTINGS, to: '/affiliate/payments/settings',
            auth: { roles: [AFFILIATE], permissions: [] },
          },
        ]
      },
      {
        id: moduleNames.AFFILIATE_REFERRAL_STATS, to: '/affiliate/referral-stats',
        auth: { roles: [AFFILIATE], permissions: ['hide'] },
      },
      {
        id: moduleNames.AFFILIATE_REFERRAL, to: '/affiliate/referral',
        auth: { roles: [AFFILIATE], permissions: [] },
      },
      {
        id: moduleNames.AFFILIATE_LOGIN_HISTORY, to: '/affiliate/login-history',
        auth: { roles: [AFFILIATE], permissions: [], permissionExclude: true },
      },

    ]
  },
  {
    id: 'system',
    auth: {
      roles: allRoles
    },
    modules: [
      {
        id: moduleNames.ADMIN_PROFILE, to: '/admin/profile',
        auth: { roles: allAdminRoles, permissions: [] },
      },
      {
        id: moduleNames.ADMIN_FAQ, to: '/admin/faq',
        auth: { roles: allAdminRoles, permissions: [] },
      },
      {
        id: moduleNames.AFFILIATE_PROFILE, to: '/affiliate/profile',
        auth: { roles: [AFFILIATE], permissions: [] },
      },
      {
        id: moduleNames.AFFILIATE_FAQ, to: '/affiliate/faq',
        auth: { roles: [AFFILIATE], permissions: [] },
      },
      {
        id: moduleNames.ADVERTISER_PROFILE, to: '/advertiser/profile',
        auth: { roles: [ADVERTISER], permissions: [] },
      },
      {
        id: moduleNames.ADVERTISER_FAQ, to: '/advertiser/faq',
        auth: { roles: [ADVERTISER], permissions: [] },
      }
    ]
  },

]

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_STAGING !== 'true') {
  const devRoutes = {
    id: 'dev',
    auth: {
      roles: allRoles
    },
    modules: [
      {
        id: `${moduleNames.DEV_BUILDER_DROPDOWN}_admin`, to: '/admin/builder',
        auth: { roles: allAdminRoles, permissions: [] },
        routes: [
          {
            id: `${moduleNames.DEV_BUILDER_MODULE}_admin`, to: '/admin/builder/module',
            auth: { roles: allAdminRoles, permissions: [] },
          }
        ]
      },
      {
        id: `${moduleNames.DEV_BUILDER_DROPDOWN}_adv`, to: '/advertiser/builder',
        auth: { roles: [ADVERTISER], permissions: [] },
        routes: [
          {
            id: `${moduleNames.DEV_BUILDER_MODULE}_adv`, to: '/advertiser/builder/module',
            auth: { roles: [ADVERTISER], permissions: [] },
          }
        ]
      },
      {
        id: `${moduleNames.DEV_BUILDER_DROPDOWN}_aff`, to: '/affiliate/builder',
        auth: { roles: [AFFILIATE], permissions: [] },
        routes: [
          {
            id: `${moduleNames.DEV_BUILDER_MODULE}_aff`, to: '/affiliate/builder/module',
            auth: { roles: [AFFILIATE], permissions: [] },
          }
        ]
      },
    ]
  }
  routes.push(devRoutes)
}


export default routes